import { months } from 'moment'

const moment = require('moment')

export const getWeekData = (weekStart) => {
  let weekData = [ weekStart.format('YYYY-MM-DD') ]
  for (let i = 1; i < 7; i++) {
    weekData.push(weekStart.add(1, 'days').format('YYYY-MM-DD'))
  }
  return weekData
}

export const getMonthData = (monthStart, monthEnd) => {
  let weekStartNumber = moment(monthStart).day()
  let weekEndNumber = moment(monthEnd).day()
  let daysInMonth = moment(monthStart).daysInMonth()
  let emptyStartAry = Array.from({ length: weekStartNumber })
  let emptyEndAry = []
  if (weekEndNumber !== 6 && weekEndNumber) {
    emptyEndAry = Array.from({ length: 6 - weekEndNumber })
  }
  let monthData = [ monthStart.format('YYYY-MM-DD') ]
  for (let i = 1; i < daysInMonth; i++) {
    monthData.push(monthStart.add(1, 'days').format('YYYY-MM-DD'))
  }
  return [...emptyStartAry, ...monthData, ...emptyEndAry]
}